import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { RouteSwitch } from 'components';

import {
  Meters as GasMeters,
  Default,
  Password
} from 'screens/shared';

import {
  GasIdle,
  GasService,
  GasSettings,
  GasMainEngineStarted
} from 'screens/Gas';

import {
  DieselIdle,
  DieselMainEngineStarted,
  DieselService,
  DieselSettings,
  Regeneration
} from 'screens/Diesel';

import styles from './Box.scss';

const Box = ({ flowId, flowType, match }) => {
  const { url } = match;

  const components = {
    gas: {
      idle: GasIdle,
      main: GasMainEngineStarted,
      service: GasService,
      settings: GasSettings
    },
    diesel: {
      idle: DieselIdle,
      main: DieselMainEngineStarted,
      service: DieselService,
      settings: DieselSettings
    }
  };

  const getComponent = name => components[flowType][name];

  let output = <div />;

  if (flowId) {
    output = (
      <RouteSwitch>
        <Route exact path={`${url}`} component={getComponent('idle')} />
        <Route exact path={`${url}/main`} component={getComponent('main')} />
        <Route exact path={`${url}/default`} component={Default} />
        <Route exact path={`${url}/password`} component={Password} />
        <Route path={`${url}/meters`} component={GasMeters} />
        <Route path={`${url}/service`} component={getComponent('service')} />
        <Route path={`${url}/settings`} component={getComponent('settings')} />
        {flowId === 3 &&
        <Route path={`${url}/regeneration`} component={Regeneration} />}
      </RouteSwitch>
    );
  }

  return (
    <div className={styles.BoxContainer}>
      <div className={styles.Box}>
        {output}
      </div>
    </div>
  );
};

Box.defaultProps = {
  flowId: null
};

Box.propTypes = {
  flowId: PropTypes.number,
  flowType: PropTypes.string.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(connect(({ workflow }) => ({
  flowId: workflow.id,
  flowType: workflow.type
}))(Box));



// WEBPACK FOOTER //
// ./src/components/Box/Box.js